import coverImg from '../../../assets/images/literature/casey-jones-cover.png';

const SEGMENTS = [
    {
        id: 'casey-jones-1',
        title: 'THE ROUNDER AND THE ENGINE',
        text: `Come all you rounders if you want to hear
A story 'bout a brave engineer,
Casey Jones was the rounder's name
'Twas on the Illinois Central that he won his fame.

Casey Jones, he loved a locomotive.
Casey Jones, a mighty man was he.
Casey Jones run his final locomotive
With the Cannonball Special on the old I.C.

Casey pulled into Memphis on Number Four,
The engine foreman met him at the roundhouse door;
Said, "Joe Lewis won't be able to make his run
So you'll have to double out on Number One."

If I can have Sim Webb, my fireman, my engine 382,
Although I'm tired and weary, I'll take her through.
Put on my whistle that come in today
Cause I mean to keep her wailing as we ride and pray.

Casey Jones, mounted the cabin,
Casey Jones, with the orders in his hand.
Casey Jones, he mounted the cabin,
Started on his farewell Journey to the promised land.`,
        morseText: `| | | COME ALL YOU ROUNDERS IF YOU WANT TO HEAR BK A STORY BOUT A BRAVE ENGINEER BK CASEY JONES WAS THE ROUNDERS NAME BK TWAS ON THE ILLINOIS CENTRAL THAT HE WON HIS FAME BK BK CASEY JONES HE LOVED A LOCOMOTIVE BK CASEY JONES A MIGHTY MAN WAS HE BK CASEY JONES RUN HIS FINAL LOCOMOTIVE BK WITH THE CANNONBALL SPECIAL ON THE OLD IC BK BK CASEY PULLED INTO MEMPHIS ON NUMBER FOUR BK THE ENGINE FOREMAN MET HIM AT THE ROUNDHOUSE DOOR BK SAID JOE LEWIS WONT BE ABLE TO MAKE HIS RUN BK SO YOULL HAVE TO DOUBLE OUT ON NUMBER ONE BK BK IF I CAN HAVE SIM WEBB MY FIREMAN MY ENGINE 382 BK ALTHOUGH IM TIRED AND WEARY ILL TAKE HER THROUGH BK PUT ON MY WHISTLE THAT COME IN TODAY BK CAUSE I MEAN TO KEEP HER WAILING AS WE RIDE AND PRAY BK BK CASEY JONES MOUNTED THE CABIN BK CASEY JONES WITH THE ORDERS IN HIS HAND BK CASEY JONES HE MOUNTED THE CABIN BK STARTED ON HIS FAREWELL JOURNEY TO THE PROMISED LAND BK`,
        estimatedSeconds: { wpm15: 420, wpm20: 315, wpm25: 250 },
        questions: [
            {
                id: 'casey-jones-q1',
                question: 'On which railroad did Casey Jones win his fame?',
                options: ['Union Pacific', 'Santa Fe', 'Illinois Central', 'Southern Pacific'],
                answer: 'Illinois Central',
                difficulty: 'Beginner'
            },
            {
                id: 'casey-jones-q2',
                question: 'Who was Casey Jones’s fireman?',
                options: ['Joe Lewis', 'Sim Webb', 'Wallace Saunders', 'Billy Miller'],
                answer: 'Sim Webb',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'casey-jones-2',
        title: 'THE CANNONBALL SPECIAL',
        text: `They pulled out of Memphis nearly two hours late,
Soon they were speeding at a terrible rate.
And the people knew by the whistle's moan
That the man at the throttle was Casey Jones.

Need more coal there, fireman Sim,
Open that door and heave it in.
Give that shovel all you got
And we'll reach Canton on the dot.

On April 30, 1900, that rainy morn,
Down in Mississippi near the town of Vaughan,
Sped the Cannonball Special only two minutes late
Traveling 70 miles an hour when they saw a freight.

The caboose number 83 was on the main line,
Casey's last words were "Jump, Sim, while you have the time."
At 3:52 that morning came the fearful end,
Casey took his farewell trip to the promised land.`,
        morseText: `THEY PULLED OUT OF MEMPHIS NEARLY TWO HOURS LATE BK SOON THEY WERE SPEEDING AT A TERRIBLE RATE BK AND THE PEOPLE KNEW BY THE WHISTLES MOAN BK THAT THE MAN AT THE THROTTLE WAS CASEY JONES BK BK NEED MORE COAL THERE FIREMAN SIM BK OPEN THAT DOOR AND HEAVE IT IN BK GIVE THAT SHOVEL ALL YOU GOT BK AND WELL REACH CANTON ON THE DOT BK BK ON APRIL 30 1900 THAT RAINY MORN BK DOWN IN MISSISSIPPI NEAR THE TOWN OF VAUGHAN BK SPED THE CANNONBALL SPECIAL ONLY TWO MINUTES LATE BK TRAVELING 70 MILES AN HOUR WHEN THEY SAW A FREIGHT BK BK THE CABOOSE NUMBER 83 WAS ON THE MAIN LINE BK CASEYS LAST WORDS WERE JUMP SIM WHILE YOU HAVE THE TIME BK AT 3 52 THAT MORNING CAME THE FEARFUL END BK CASEY TOOK HIS FAREWELL TRIP TO THE PROMISED LAND BK`,
        estimatedSeconds: { wpm15: 380, wpm20: 285, wpm25: 230 },
        questions: [
            {
                id: 'casey-jones-q3',
                question: 'How fast was the train traveling when they saw the freight?',
                options: ['50 miles an hour', '70 miles an hour', '90 miles an hour', '100 miles an hour'],
                answer: '70 miles an hour',
                difficulty: 'Intermediate'
            },
            {
                id: 'casey-jones-q4',
                question: 'What was the number of the caboose on the main line?',
                options: ['382', 'Number One', '83', 'Number Four'],
                answer: '83',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'casey-jones-3',
        title: 'THE PROMISED LAND',
        text: `Casey Jones, he died at the throttle,
With the whistle in his hand.
Casey Jones, he died at the throttle,
But we'll all see Casey in the promised land.

His wife and three children were left to mourn
The tragic death of Casey on that April morn.
May God through His goodness keep them by His grace
Till they all meet together in that heavenly place.

Casey's body lies buried in Jackson, Tennessee
Close beside the tracks of the old I.C.
May his spirit live forever throughout the land
As the greatest of all heroes of a railroad man.

Casey Jones, he died at the throttle,
Casey Jones, with the whistle in his hand.
Casey Jones, he died at the throttle,
But we'll all see Casey in the promised land.`,
        morseText: `CASEY JONES HE DIED AT THE THROTTLE BK WITH THE WHISTLE IN HIS HAND BK CASEY JONES HE DIED AT THE THROTTLE BK BUT WELL ALL SEE CASEY IN THE PROMISED LAND BK BK HIS WIFE AND THREE CHILDREN WERE LEFT TO MOURN BK THE TRAGIC DEATH OF CASEY ON THAT APRIL MORN BK MAY GOD THROUGH HIS GOODNESS KEEP THEM BY HIS GRACE BK TILL THEY ALL MEET TOGETHER IN THAT HEAVENLY PLACE BK BK CASEYS BODY LIES BURIED IN JACKSON TENNESSEE BK CLOSE BESIDE THE TRACKS OF THE OLD IC BK MAY HIS SPIRIT LIVE FOREVER THROUGHOUT THE LAND BK AS THE GREATEST OF ALL HEROES OF A RAILROAD MAN BK BK CASEY JONES HE DIED AT THE THROTTLE BK CASEY JONES WITH THE WHISTLE IN HIS HAND BK CASEY JONES HE DIED AT THE THROTTLE BK BUT WELL ALL SEE CASEY IN THE PROMISED LAND BK`,
        estimatedSeconds: { wpm15: 450, wpm20: 340, wpm25: 270 },
        questions: [
            {
                id: 'casey-jones-q5',
                question: 'Where is Casey Jones buried?',
                options: ['Memphis, Tennessee', 'Jackson, Tennessee', 'Canton, Mississippi', 'Vaughan, Mississippi'],
                answer: 'Jackson, Tennessee',
                difficulty: 'Intermediate'
            },
            {
                id: 'casey-jones-q6',
                question: 'What did Casey have in his hand when he died?',
                options: ['The throttle', 'A message', 'The whistle', 'The orders'],
                answer: 'The whistle',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'casey-jones',
    type: 'poem',
    title: 'THE BALLAD OF CASEY JONES',
    author: 'Wallace Saunders',
    publicationDate: '1902',
    coverImage: coverImg,
    genres: ['Folklore', 'Railroad', 'History'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "The legendary ballad of a brave engineer racing against time, featuring 1900s locomotive action and telegraph orders.",
    isNew: true,
    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),
    metadata: {
        setting: 'Tennessee & Mississippi, USA',
        period: '1900',
        themes: ['Heroism', 'Duty', 'Railroads'],
        difficulty: 'Intermediate',
        estimatedReadingTimeMinutes: 20,
        segments: SEGMENTS.length
    }
};
